// ExternalCompanyUsers.jsx
// 외부 회사별 직원 관리 페이지 (/admin/ext/:code/users)
// 회사 확인은 useExtCompany 가 한다 (2026-09-10 — 다섯 화면이 복붙하던 코드를 모았다).
// 제목에 "(회사명)" 을 붙이지 않는다 — 어느 회사인지는 사이드바 상단 선택창이 알려준다.

import React from 'react';
import { useParams } from 'react-router-dom';
import { useExtCompany, ExtCompanyFallback } from './useExtCompany';
import UserManagement from './UserManagement';

export default function ExternalCompanyUsers() {
  const { code } = useParams();
  const { company, loading, error } = useExtCompany(code);
  if (!company) return <ExtCompanyFallback loading={loading} error={error} />;

  return (
    <UserManagement
      pageTitle="직원 관리"
      apiBase={`/api/admin/ext/${company.code}/users`}
      entityLabel="직원"
      showBulk={false}
      companyCode={company.code}
      departmentType="external"
    />
  );
}
